import { useNavigate } from 'react-router';
import { NAV_PATH } from '@/router/constants';
import useEventDetail from '@/pages/customer-support/event/hook/useEventDetail';

const EventDetailPage = () => {
	const navigate = useNavigate();
	useEventDetail();

	// 리스트 페이지로 가기
	const eventDetailClickGoList = () => {
		navigate(`${NAV_PATH.CUSTOMER_SUPPORT.EVENT}`);
	};
	return (
		<main id="sub" className="sub event">
			<section id="" className="sub-content">
				<div className="sub-inner">
					<div className="board-detail">
						<div className="detail-head">
							<p className="title-tag">진행중인 이벤트</p>
							<strong className="title"></strong>
							<div className="date">
								<span className="js-event-stDt"></span> ~ <span className="js-event-edDt"></span>
							</div>
						</div>

						<div className="detail-body">
							<div className="text-box"></div>
						</div>

						<div className="detail-foot">
							<ul>
								<li>
									<a href="" className="detail-next-btn">
										<i className="ico-board-up" aria-hidden="true"></i>
										다음글
										<p className="title"></p>
									</a>
								</li>
								<li>
									<a href="" className="detail-prev-btn">
										<i className="ico-board-down" aria-hidden="true"></i>
										이전글
										<p className="title"></p>
									</a>
								</li>
							</ul>
						</div>

						<div className="button-group">
							<button className="btn primary" onClick={eventDetailClickGoList}>
								목록
							</button>
						</div>
					</div>
				</div>
			</section>
		</main>
	);
};

export default EventDetailPage;
